export default "__VITE_ASSET__DF0urt0P__"